module.exports = __webpack_public_path__ + "img/search_calendar.0514cf93.svg";